/**
 * Extract all allowed routes from menu configuration
 * @param {Array} menuData - Menu configuration array
 * @returns {Array} Flat array of all allowed routes
 */
export const extractAllowedRoutes = (menuData) => {
  if (!menuData || !Array.isArray(menuData)) return [];

  const routes = [];
  const allowedExceptions = ['/emi-calculator', '/dashboard', '/profile']; // Always allowed routes

  menuData.forEach((item) => {
    // Add main route if it exists
    if (item.to) {
      routes.push(item.to);
    }

    // Add nested routes from content/submenu
    if (item.content && Array.isArray(item.content)) {
      item.content.forEach((subItem) => {
        if (subItem.to) {
          routes.push(subItem.to);
        }
      });
    }
  });

  // Add exceptions
  return [...new Set([...routes, ...allowedExceptions])];
};

/**
 * Check if user has access to a specific route
 * @param {string} route - The route to check
 * @param {Array} allowedRoutes - Array of allowed routes
 * @returns {boolean} True if user has access
 */
export const hasRouteAccess = (route, allowedRoutes) => {
  if (!route || !allowedRoutes) return false;

  // Check exact match
  if (allowedRoutes.includes(route)) {
    return true;
  }

  // Check partial match (e.g., /loans/123 matches /loans/*)
  return allowedRoutes.some((allowedRoute) => {
    const allowedPattern = allowedRoute.replace(/\/[^/]+$/, '/*');
    const routePattern = route.substring(0, allowedRoute.length);
    return routePattern === allowedRoute;
  });
};

/**
 * Get accessible routes from menu data for a specific role
 * @param {Array} menuData - Menu configuration data
 * @returns {Array} Array of accessible routes
 */
export const getAccessibleRoutes = (menuData) => {
  return extractAllowedRoutes(menuData);
};
